import { cva } from '@/styled-system/css';

export const cardHeaderRecipe = cva({
  base: {
    'marginBlockEnd': 'loose',

    '& > [data-c11n-component="Heading"]': {
      textStyle: 'heading-xs',
    },
  },
  variants: {
    divider: {
      true: {
        paddingBlockEnd: 'default',
        borderBlockEndWidth: '{borderWidths.default}',
        borderBlockEndStyle: 'solid',
        borderBlockEndColor: 'border.muted-alt',
      },
      false: {},
    },
  },
});
